import { render } from "./Blog3Columns.vue?vue&type=template&id=12246578&scoped=true"
import script from "./Blog3Columns.vue?vue&type=script&lang=js"
export * from "./Blog3Columns.vue?vue&type=script&lang=js"

import "./Blog3Columns.vue?vue&type=style&index=0&id=12246578&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12246578"]])

export default __exports__